import React from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import fcbLogo from 'assets/images/foodcourt-business-logo.png';
import { DateRangeType } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';
import { MemberTransactionSummaryType } from 'models/transactions.model';

type Props = {
  elementRef: React.LegacyRef<HTMLDivElement>;
  dateRange: DateRangeType['date'];
  summary: MemberTransactionSummaryType;
};

const StatementSummary = (props: Props) => {
  const { elementRef, dateRange, summary } = props;
  const { activeCompany } = useDashboardContext();

  return (
    <div ref={elementRef} className='fixed -top-[200vh] -z-10 w-[595px]'>
      <div className='flex items-start justify-between px-[22px] pt-6 pb-4 border-b border-[#EAEAEB]'>
        <img src={fcbLogo} className='w-[109px]' />
        <article className='max-w-[138px] text-right'>
          <p className='text-xs font-semibold'>{activeCompany.name}</p>
          <p className='text-[10px] leading-[16px]'>{activeCompany.address}</p>
        </article>
      </div>
      <div className='flex flex-col gap-3 px-[22px] pt-6'>
        <article>
          <p className='text-xs font-medium text-[#E60A2B]'>Account Summary</p>
          <p className='text-[10px] leading-4 text-[#2E3031]'>
            {moment(dateRange.startDate).format('MMM D, YYYY')}&nbsp;-&nbsp;
            {moment(dateRange.endDate).format('MMM D, YYYY')}
          </p>
        </article>
        <ul className='flex flex-col gap-2 p-4 pt-1 border text-xs border-[#EAEAEB]'>
          <li className='flex items-center justify-between'>
            <p>Total new members</p>
            <p className='text-[#5E6164]'>{summary.new_members_count}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Total amount allocated</p>
            <p className='text-[#5E6164]'>{formatCurrency(summary.total_allocation)}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Total amount spent</p>
            <p className='text-[#5E6164]'>{formatCurrency(summary.total_spent)}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Total amount gifted</p>
            <p className='text-[#5E6164]'>{formatCurrency(summary.total_gift)}</p>
          </li>
        </ul>
        <p className='text-xs font-medium text-[#E60A2B] py-4'>Transaction Breakdown</p>
      </div>
    </div>
  );
};

export default StatementSummary;
